var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{staticClass:"my-0 btn",attrs:{"type":"primary","simple":"","icon":""},on:{"click":function($event){return _vm.ShowModal()}}},[_c('i',{staticClass:"d-inline-block tim-icons icon-settings-gear-63"})])
}
var staticRenderFns = []

export { render, staticRenderFns }